import React from 'react';
import type { V1QuestionValidation } from '../types/v1-questionnaire.types';

interface V1TextQuestionProps {
  type: 'text' | 'email' | 'number';
  value: string;
  onChange: (value: string) => void;
  onBlur?: () => void;
  placeholder?: string;
  validations?: V1QuestionValidation;
  hasError?: boolean;
}

export const V1TextQuestion: React.FC<V1TextQuestionProps> = ({
  type,
  value,
  onChange,
  onBlur,
  placeholder,
  validations,
  hasError = false,
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    
    // Apply max length validation if specified
    if (validations?.maxLength && newValue.length > validations.maxLength) {
      return;
    }
    
    onChange(newValue);
  };

  return (
    <input
      type={type}
      value={value}
      onChange={handleChange}
      onBlur={onBlur}
      placeholder={placeholder}
      className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 ${
        hasError ? 'border-red-300' : 'border-gray-300'
      }`}
      maxLength={validations?.maxLength}
      min={type === 'number' ? validations?.minValue : undefined}
      max={type === 'number' ? validations?.maxValue : undefined}
    />
  );
};